export enum Flipper {
  retailerFundedMarketing = 'rt_retailer_funded_marketing',
  retailerFundedMarketingPhase4 = 'rt_retailer_funded_marketing_phase4',
}
